/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_PAYOUTS = gql`
  query GetMyPayouts($input: GetListOfPayoutsInput) {
    getMyPayouts(input: $input) {
      currentPage
      data {
        acknowledeged
        amount
        id
        policyId
        status
        payment {
          status
          paymentMode
          paymentId
          paidOn
          amount
          policyId
          from
        }
      }
      pageSize
      totalCount
      totalPages
    }
  }
`;
